<template>
  <v-app id="inspire">
    <v-content>
      
      <v-container class="bckcolor" fluid fill-height>
        
        <v-layout align-center justify-center>
          <v-flex xs12 sm12 md8>
            <v-card flat class="login-container elevation-5">
                <v-container>
              <v-form ref="form" v-model="valid" lazy-validation class="container">
        <v-layout row wrap>
            <v-flex xs12>
                <h5 style="text-decoration:underline;font-weight:bold;text-decoration-color: #e53935;text-decoration-style: solid;text-align:center">
                  Create A Customer Account
                </h5>
            </v-flex>
            <v-flex xs12 style="padding-top:15px">
                <p>Please enter below details to create an account!</p>
            </v-flex>
            
            <v-flex xs12>
                <v-text-field v-model="form.fullName" label="Enter your Full Name *" :rules="emptyRule" required></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md6 style="margin-top:-15px;padding-right:5px">
                <v-text-field type="Number" v-model="form.mobileNumber" label="Mobile No *" :rules="[rules.mobileno]" required></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md6 style="margin-top:-15px">
                <v-text-field v-model="form.email" label="Email ID *" :rules="[rules.email]" required></v-text-field>
            </v-flex>
            <v-flex xs12 style="margin-top:-15px">
            <v-text-field
              type="password"
              v-model="form.passwords"
              label="Password *"
              :rules="[rules.required, rules.min, rules.number, rules.capital, rules.small, rules.spec]"
              required
            ></v-text-field>
            </v-flex>

          <v-flex xs12 style="text-align:right;padding-top:15px">
            <v-btn depressed color="black" dark @click="back()">Cancel</v-btn>
            <v-btn large depressed :loading="btnSave" color="#e53935" dark @click="onSubmit()">Submit</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

  </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data: () => ({
    menu: false,
    loading: false,
    dialog: false,
    loginBtn: false,
    drawer: null,
    Password: null,
    passwordShow: false,
    role: sessionStorage.roles,

    btnSave: false,


      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        min: value =>
          (value != null && value.length >= 6) || "Min 6 characters",
        number: value => {
          const pattern = /[0-9]+/;
          return pattern.test(value) || "Min one number";
        },
        capital: value => {
          const pattern = /[A-Z]+/;
          return pattern.test(value) || "Min one capital letter";
        },
        small: value => {
          const pattern = /[a-z]+/;
          return pattern.test(value) || "Min one small letter";
        },
        spec: value => {
          const pattern = /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~ ]+/;
          return pattern.test(value) || "Min one special character";
        },
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
        },
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },

    form: {
        fullName: null,
        mobileNumber: null,
        email: null,
        passwords: null
      }
  }),
  props: {
    source: String
  },

  mounted() {
  },

  methods: {
    back() {
      this.$router.go(-1);
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `Customers1`,
            {
              fullName: this.form.fullName,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              email: this.form.email,
              passwords: this.form.passwords
            }
          )
          .then(() => {
            this.btnSave = false;
            this.$router.push("/login");
            this.$toaster.success(`Successfully Registered`);
          })
          .catch(err => {
            //this.$toaster.error(err.message);
            this.btnSave = false;
            this.$toaster.error(`Email ID or Mobile Number is already registered`);
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  }

  
};
</script>

<style lang="css" scoped>
@import url('https://fonts.googleapis.com/css2?family=Piedra&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Charm&family=Homemade+Apple&display=swap');

.wings {
font-family: 'Piedra', cursive;
}
.tag {
  font-family: 'Charm', cursive;
}
.login-form {
  padding: 40px;
}
.bckcolor {
  background-image: url('https://www.anstro.co.za/wp-content/uploads/2017/08/Anstro-Catering-Equipment-Slide1-1030x332.jpg');
  background-size: cover;
}
.cursr {
  cursor: pointer;
}
.v-btn {
  margin-left: 0px;
}
.txt_dec:hover {
    text-decoration: underline !important;
}
.loginPage {
  background-image: url('../../assets/loginbg.jpg');
  background-size:cover
}
.call-button-container {
  margin: auto;
  width: 233px;
  height: 74px;
  vertical-align: middle;
  padding: 10px;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
/* .pos {
  position: absolute;
  top: 0;
  right: 10px;
  z-index: 999;
} */
</style>
